/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = IP 1 = CIDR 2 = ASN 3 = Country 4 = Organization 5 = JA4
 */
export type AccessListType = 0 | 1 | 2 | 3 | 4 | 5;

export const AccessListType = {
  IP: 0 as AccessListType,
  CIDR: 1 as AccessListType,
  ASN: 2 as AccessListType,
  Country: 3 as AccessListType,
  Organization: 4 as AccessListType,
  JA4: 5 as AccessListType,
};
